import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	accountType: string;
}

const Wrapper = styled.div`
  width: 18em;
  margin: auto;
  text-align: center;
  .button-container{
     button {
      margin: auto;
      width: 10em;
      height: 2em;
      border: 2px solid red;
      border-radius: 8px;
      background-color: white;
      padding: 0.4em;
      font-weight: 600;
      color: red;
    }
    margin-bottom: 2.614em;
  }
`;

const Header = styled.div`
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 1em;
`;

export const CreditCardInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
			{props.accountType === 'consumer' && (
				<Wrapper>
					<Header>Maksutapa</Header>
					<div className={'button-container'}>
						<Link to="/account/creditCardInformation">
							<button>Vaihda maksukortti</button>
						</Link>
					</div>
				</Wrapper>
			)}
		</div>
	);
};